import { useLucideIconNode } from '@/hooks/useLucideIconNode'
import { Icon, type LucideProps } from 'lucide-react'
import type { IconName } from 'lucide-react/dynamic'

export interface DynamicIconProps extends LucideProps {
	name: IconName
	fallback?: () => React.ReactNode
}

/**
 * Lucide's own `DynamicIcon` holds the loaded icon in component state, so every mount renders
 * nothing until the icon's chunk import resolves again: a table that rebuilds its cells on each
 * poll shows the icon blinking in and out. The shared cache behind `useLucideIconNode` makes only
 * the first mount of a given name async.
 */
export function DynamicIcon({ name, fallback: Fallback, ...props }: DynamicIconProps) {
	const iconNode = useLucideIconNode(name)
	if (!iconNode) {
		return Fallback ? <Fallback /> : null
	}
	return <Icon {...props} iconNode={iconNode} />
}
